var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8187 20.1784H4.31873C2.83826 20.1787 2.31873 19.2721 2.31873 19.003L2.31873 9.81634C2.31873 9.43497 2.31871 8.50299 3.31872 8.50299C4.31873 8.50299 4.31873 9.43497 4.31873 9.81634V18.1843H15.3187V10.003C15.3187 9.62162 15.3187 8.50299 16.3187 8.50299C17.3187 8.50299 17.3187 9.52587 17.3187 10.003V19.1843C17.319 19.5659 16.5794 20.1784 15.8187 20.1784Z",
    fill: "#1A2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.4254 8.96858C17.4254 8.96858 16.544 8.0496 16.4254 7.96858L10.6839 3.58897C10.3303 3.31922 9.84101 3.31545 9.48327 3.57973L2.81873 8.50299C2.50413 8.71796 1.63677 9.14739 0.981314 8.46858C0.277804 7.74 1.0188 7.18286 1.33294 6.96858L8.71191 1.50299C8.94557 1.34372 10.2288 0.933019 11.2119 1.67708L18.8693 6.93011C18.9067 6.95572 18.9425 6.98369 18.9734 7.01673C19.2833 7.3476 19.3751 7.8611 19.2716 8.31413C19.21 8.58396 18.7022 8.96858 18.4254 8.96858Z",
    fill: "#1A2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.1111 4.21213C16.598 4.21213 16.2222 3.74314 16.2222 3.45402V2.69592L15 2.6787C14.6623 2.6787 14 2.13742 14 1.6787C14 1.21998 14.6623 0.678703 15 0.678703H17.1111C17.5583 0.678703 18 1.29965 18 1.6787V3.48644C18 3.8655 17.6242 4.21213 17.1111 4.21213Z",
    fill: "#1A2021"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.0bf9290967904c9c4e2aca73e4d7aa68.svg";
export { ForwardRef as ReactComponent };